<div class="flex-1 flex flex-col">
  <section class="container mb-[48px] md:mb-[60px]">
    <ng-container *transloco="let t; prefix: 'sell-with-us.top-section'">
      <div class="max-w-[794px] mx-auto mt-12">
        <h1 class="text-center text-black rfs:text-5xl mb-6">
          {{ t("title.part01") }}
          <span class="text-primary-700">{{ t("title.part02") }}</span>
          {{ t("title.part03") }}
        </h1>
        <p class="text-center text-gray-800 mt-6 mb-10">
          {{ t("description") }}
        </p>
        <div class="text-center" >
          <button [localizedRouterLink]="['/property-upload-wizard']" class="btn-primary">{{ t("button") }}</button>
        </div>
      </div>
    </ng-container>
  </section>
  <section class="container mb-[48px] md:mb-[60px]">
    <ng-container *transloco="let t; prefix: 'sell-with-us.hero-section'">
      <section class="w-full">
        <div
          imageScrollAnimation
          style="transform:scale(0.7)"
          class="justify-self-center w-[358px] h-[222px] md:w-[864px] md:h-[346px] bg-[url('./assets/sell-with-us/sell-with-us.png')] bg-no-repeat bg-cover rounded-[8px]"
        ></div>
      </section>

      <div class="max-w-[794px] mx-auto mt-28">
        <h4 class="text-center text-black rfs:text-3xl mb-6">
          {{ t("header") }}
        </h4>
      </div>
    </ng-container>
  </section>
  <section class="container mb-[48px] md:mb-[60px]">
    <app-reasons-to-sell></app-reasons-to-sell>
  </section>
  <section class="mb-[48px] md:mb-[60px]">
    <app-listing-swiper></app-listing-swiper>
  </section>
  <section class="container mb-[48px] md:mb-[60px]">
    <app-steps></app-steps>
  </section>
  <section class="container mb-[48px] md:mb-[60px]">
    <app-enlist-property></app-enlist-property>
  </section>
</div>
